import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

export function bannerConnected() {
    const banner = document.querySelector('.banner--connected');

    if (!banner) {
        return;
    }

    const tl = gsap.timeline();

    gsap.set('#line-mask-path', {
        drawSVG: '0% 0%',
        opacity: 0
    });

    tl.to('.text-one', {
        scale: 1,
        opacity: 1,
        ease: 'elastic.out(0.5,0.5)',
        duration: 2
    });
    tl.to(
        '.text-two',
        {
            scale: 1,
            opacity: 1,
            ease: 'elastic.out(0.5,0.5)',
            duration: 1.5
        },
        '>-1'
    );
    tl.to(
        '#line-mask-path',
        {
            duration: 1,
            drawSVG: '0% 100%',
            opacity: 1,
            ease: 'power2.in'
        },
        '<'
    );
    tl.to('.text-one', {
        rotate: -7,
        duration: 3,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        stagger: {
            amount: 1
        }
    });
    tl.to(
        '.text-two',
        {
            rotate: 8,
            duration: 2.8,
            ease: 'sine.inOut',
            repeat: -1,
            yoyo: true,
            stagger: {
                amount: 1
            }
        },
        '<'
    );

    gsap.to('.banner__content', {
        opacity: 0,
        y: -100,
        scrollTrigger: {
            trigger: '.banner--connected',
            start: 'clamp(top 130px)',
            scrub: 2
        }
    });
}
